<ion-app>
  <ion-split-pane contentId="main-content" when="sm" [disabled]="!isLoggedIn">
    <!-- Left Menu -->
    <ion-menu contentId="main-content" type="overlay">
      <ion-content>
        <a routerLink="/transaction"><img class="ottremit-logo" src="assets/images/ottremit-logo-white.svg"
            height="80"></a>

        <ion-button class="btn-send-money" color="secondary" routerLink="/transaction/step-amount">{{
          'sidenav.sendMoney' | translate }} <ion-icon name="arrow-forward-outline"></ion-icon></ion-button>
        <ion-menu-toggle auto-hide="false" *ngFor="let p of pages; let i = index">
          <ion-item routerDirection="root" [routerLink]="[p.url]" lines="none" detail="false"
            routerLinkActive="selected">
            <ion-icon aria-hidden="true" slot="start" [src]="p.icon"></ion-icon>
            <ion-label>{{ p.title | translate }}</ion-label>
          </ion-item>
        </ion-menu-toggle>
        <ion-menu-toggle auto-hide="false">
          <ion-item routerDirection="root" (click)="signout()" routerLink="login" lines="none" detail="false"
            routerLinkActive="selected">
            <ion-icon aria-hidden="true" slot="start" src="assets/images/icon-signout.svg"></ion-icon>
            <ion-label>{{ 'sidenav.signOut' | translate }}</ion-label>
          </ion-item>
        </ion-menu-toggle>

        <div class="qrcode-wrapper">
          <div class="left">
            <strong>Download</strong><br>OTT Remit App
          </div>
          <div class="right">
            <img src="assets/images/ottremit-download.png" alt="Download OTT Remit" width="90">
          </div>
        </div>

      </ion-content>
    </ion-menu>

    <!-- Right Content -->
    <div id="main-content">
      <!-- Globel Header -->
      <ion-header>
        <ion-toolbar class="with-border">
          <img *ngIf="!isLoggedIn" src="assets/images/ottremit-h-logo.svg" height="54" slot="start">
          <ion-title></ion-title>
          <ion-buttons slot="end" *ngIf="isLoggedIn">
            <ion-button class="btn-top-nav" expand="block" fill="clear" routerLink="/account" *ngIf="currentUser">
              Hi, {{ currentUser.user.cfirstname }}
            </ion-button>
            <ion-button class="btn-top-nav" expand="block" fill="clear" routerLink="/my-points">
              <app-number-tracker *ngIf="myPoints$ | async as myPoints" [target]="myPoints.currentPoint"
                [factor]="myPoints.currentPoint>100000 ? 500 : (myPoints.currentPoint>10000?100 : 50)"
                [countInterval]="10"></app-number-tracker><span class="unit">&nbsp;{{'common.pts'|translate}}</span>
            </ion-button>
            <ion-button id="btn-checkin" expand="block" color="primary" fill="solid" (click)="dailyCheckin()"
              [disabled]="hasSigninToday">
              <ion-icon *ngIf="!hasSigninToday" src="assets/images/icon-calendar.svg"></ion-icon>
              <ion-icon *ngIf="hasSigninToday" name="checkmark-outline"></ion-icon>
              {{'tabs.points.pointsStore.checkIn'|translate}}
              <span [@slideInOutCC] *ngIf="showDailyCheckInPoints"
                style="color: var(--ion-color-warning);font-weight: bold;font-size: 24px;position: absolute;left: 0;">
                +{{dailyBonusPoints}}
              </span>
            </ion-button>
          </ion-buttons>
        </ion-toolbar>
      </ion-header>
      <ion-router-outlet></ion-router-outlet>
    </div>
  </ion-split-pane>
</ion-app>

<!-- 成功签到弹窗 -->
<ion-modal [isOpen]="isDailyBonusSuccessModalOpen" class="daily-bonus">
  <ng-template>
    <ion-content class="ion-padding" style="text-align: center;">
      <h1>{{ 'tabs.points.pointsStore.dailyBonus'|translate }}</h1>
      <p>{{ 'tabs.points.pointsStore.dailyBonusPoints'|translate: { points: dailyBonusPoints } }}</p>
      <img src="assets/images/daily-bonus.svg">
      <ion-button (click)="setDailyBonusSuccessModalOpen(false)">{{ 'common.ok'|translate }}</ion-button>
    </ion-content>
  </ng-template>
</ion-modal>